import type { BatchTransitionRowProps } from "./batch-transition-row.type";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { StateTag } from "@/modules/state-tag";

import { useBatchTransitionRow } from "./batch-transition-row.hook";

const { Paragraph } = Typography;

const BatchTransitionRow = ({ state, form }: BatchTransitionRowProps) => {
  const { t } = useTranslation();
  const { type, count, noNextStates } = useBatchTransitionRow(state);

  return (
    <div className="batch-transition-row">
      <Paragraph>
        <strong>{count}</strong> {t(`${type}:name`, { count })}{" "}
        <StateTag type={type} value={state} asText />
      </Paragraph>
      {noNextStates ? (
        <Paragraph className="batch-transition-row-info">
          {t("global:batchTransition.noNextStates")}
        </Paragraph>
      ) : (
        form
      )}
    </div>
  );
};

export default BatchTransitionRow;
